import type { EditorAction } from "../../editor/reducers";
import type { Dispatch } from "react";
import type { HybridRegionCreationTabFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { NavbarTabContent } from "../../shell/NavbarTabContent";
import { makeTabIdentifier } from "../../editor/reducers";
import { NavbarTabCloseButton } from "../../shell/NavbarTabCloseButton";
import { ScrollArea } from "@acdc2/ui/components/scroll-area";
import { HybridRegionEditor } from "./HybridRegionEditor";

type Props = {
  fragment: HybridRegionCreationTabFragment;
  dispatch: Dispatch<EditorAction>;
};

export function HybridRegionCreationTab({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  return (
    <NavbarTabContent
      value={makeTabIdentifier("hybrid", fragment.id)}
      title={t("HybridRegionCreationTab.title")}
      right={<NavbarTabCloseButton dispatch={dispatch} />}
    >
      <ScrollArea className="flex-1">
        <HybridRegionEditor regionId={fragment.id} />
      </ScrollArea>
    </NavbarTabContent>
  );
}
